import { Flex, FlexItem } from '@bfa/common-ui';
import React from 'react';
import { ButtonFlexItem, Dot, DotsFlex, NextButton } from './StepFooter.styled';
var StepFooter = function (_a) {
    var currentStep = _a.currentStep, onEdgeButtonClick = _a.onEdgeButtonClick, numberSteps = _a.numberSteps, isMobile = _a.isMobile;
    var steps = Array.from({ length: numberSteps - 2 }, function (v, i) { return i; });
    return (React.createElement(Flex, null,
        React.createElement(ButtonFlexItem, null),
        React.createElement(FlexItem, { flexGrow: 2 },
            React.createElement(DotsFlex, null, steps.map(function (step) { return (React.createElement(Dot, { key: step + 1, indexedStep: step + 1, currentStep: currentStep })); }))),
        React.createElement(ButtonFlexItem, null, isMobile && (React.createElement(NextButton, { variant: "primary", onClick: onEdgeButtonClick },
            React.createElement("span", { className: "icon-ipsy-caret-right" }))))));
};
export default StepFooter;
